<template>
  <tr>
    <td class="v-align-middle">
      <span>{{invoice.date | moment-date }}</span>
    </td>
    <td class="v-align-middle">
      <span>{{ invoice.organization.display_name }}</span>
    </td>
    <td class="society-group">
      <span>{{invoice.erp_id}}</span>
    </td>
    <td class="v-align-middle">
      <span>{{(invoice.ttc_amount/100).toFixed(2)}}€</span>
    </td>
    <td class="v-align-middle">
      <span>{{invoice.decoded_special_account}}</span>
    </td>
    <td class="v-align-middle">
      <template v-if="invoice.paid || !invoice.organization.disabled_for_tup">
        <span v-if="invoice.paid">Payée</span>
        <span v-else>En attente de règlement</span>
      </template>

      <template v-else>Transférée à SOFRADOM</template>
    </td>
    <td>
      <a :href="invoice_path" tag="button" class="btn btn-complete btn-sm m-t-10" target="_blank" v-if="invoice.pdf_path">
        <i class="fa fa-download" aria-hidden="true"></i>
        <span>PDF</span>
      </a>
    </td>
  </tr>
</template>

<script type="text/babel">
  import cookies from "cookiesjs"
  export default {

    props:["invoice"],

    computed : {
      invoice_path() {
        return __INVOICES_URL__ + '/customers/' + this.$route.params.id + '/invoices/' + this.invoice.id +'/show?token=' + cookies('token')
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '~pages_sass/_var.scss';

  td {
    &:first-child {
      &::before {
        display: none !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// client/components/Customer/Invoices/Item.vue